(function () {
  const toBoolean = (value) => value === "true";

  const initCardsSliders = () => {
    const sliders = Array.from(document.querySelectorAll(".cards-slider"));

    if (sliders.length === 0) return;

    sliders.forEach((slider) => {
      if (slider.dataset.initialized === "true") return;

      const sectionId = slider.dataset.id;
      const slideCount = slider.querySelectorAll(".swiper-slide").length;
      const speed = Number(slider.dataset.speed || 5) * 1000;
      const perRow = Number(slider.dataset.perRow || 6);
      const mobile = Number(slider.dataset.mobile || 1.2);
      const autoplay = toBoolean(slider.dataset.autoplay);
      const enableNavigation = toBoolean(slider.dataset.navigation);
      const stopAutoplaySlider = toBoolean(slider.dataset.stopAutoplay);
      let autoplayParams = {};

      if (autoplay) {
        autoplayParams = {
          autoplay: {
            delay: 0,
            disableOnInteraction: false,
            pauseOnMouseEnter: stopAutoplaySlider,
          },
        };
      }

      const swiper = new Swiper(`#${sectionId} .cards-slider .swiper`, {
        loop: true,
        loopAdditionalSlides: slideCount,
        loopedSlides: slideCount,
        longSwipesRatio: 0.1,
        slidesPerView: mobile,
        allowTouchMove: true,
        spaceBetween: 2,
        speed: speed,
        breakpoints: {
          768: {
            slidesPerView: 4.5,
          },
          1100: {
            slidesPerView: perRow + 0.4,
          },
        },
        ...autoplayParams,
      });

      slider.dataset.initialized = "true";

      if (autoplay && stopAutoplaySlider) {
        let duration;
        let distanceRatio;
        let startTimer;

        const stopAutoplay = () => {
          if (startTimer) clearTimeout(startTimer);

          swiper.setTranslate(swiper.getTranslate());

          const currentSlideWidth = swiper.slides[swiper.activeIndex].offsetWidth;
          distanceRatio = Math.abs(
            (currentSlideWidth * swiper.activeIndex + swiper.getTranslate()) /
              currentSlideWidth
          );

          duration = swiper.params.speed * distanceRatio;
          swiper.autoplay.stop();
        };

        const startAutoplay = (delay = duration) => {
          startTimer = setTimeout(() => {
            swiper.autoplay.start();
          }, delay);
        };

        slider.addEventListener("mouseenter", function () {
          stopAutoplay();
        });

        slider.addEventListener("mouseleave", function () {
          const distance = swiper.width * swiper.activeIndex + swiper.getTranslate();

          duration = distance !== 0 ? duration : 0;
          swiper.slideTo(swiper.activeIndex, duration);
          startAutoplay();
        });

        if (enableNavigation) {
          const switchSpeed = 1000;
          const totalSlides = swiper.slides.length;

          const handleSwitch = (direction) => {
            stopAutoplay();

            if (direction === "next") {
              const nextIndex = (swiper.realIndex + 1) % totalSlides;
              swiper.slideToLoop(nextIndex, switchSpeed);
            } else {
              const prevIndex =
                (swiper.realIndex - 1 + totalSlides) % totalSlides;
              swiper.slideToLoop(prevIndex, switchSpeed);
            }

            startAutoplay(switchSpeed);
          };

          document
            .querySelector(`#${sectionId} .cards-slider-button-next`)
            ?.addEventListener(
              "click",
              function () {
                handleSwitch("next");
              },
              false
            );

          document
            .querySelector(`#${sectionId} .cards-slider-button-prev`)
            ?.addEventListener(
              "click",
              function () {
                handleSwitch("prev");
              },
              false
            );
        }
      }
    });
  };

  document.addEventListener("DOMContentLoaded", () => {
    initCardsSliders();

    document.addEventListener("shopify:section:load", () => {
      initCardsSliders();
    });
  });
})();
